import './Peersets.css';

import { Fragment } from 'react';
import clsx from 'clsx';
import { useDatasetContext } from '../../../../../hooks/context/useDatasetContext';
import PeersetButton from '../PeersetButton/PeersetButton';
import Tooltip from '../../../Tooltip/Tooltip';
import PeersetPopover from '../PeersetPopover/PeersetPopover';

interface PeersetsProps {
  className?: string;
}

const Peersets = ({ className }: PeersetsProps) => {
  const { dataset, datasetId } = useDatasetContext();

  if (!dataset?.peersets) return null;

  return (
    <div className={clsx('peerset-tabs-container', className)}>
      {dataset.peersets.map((peerset, index) => {
        const id = `peerset-${index}`;
        const isActive =
          peerset.datasetId === datasetId ||
          peerset.peersets?.some((v) => v.datasetId === datasetId);

        return (
          <Fragment key={index}>
            <span className={isActive ? 'peerset-tab active' : 'peerset-tab'}>
              <PeersetButton
                peerset={peerset}
                popoverTarget="peerset-label"
                triggerId={id}
              />
            </span>
            <Tooltip target=".peerset-label" />
            <PeersetPopover peerset={peerset} triggerId={id} />
          </Fragment>
        );
      })}
    </div>
  );
};

export default Peersets;
